import logo from '../assets/logo.png';
import footerLogo from '../assets/footer-logo.png';
import menuBg from '../assets/menuBg.svg';
import main from '../assets/main-2.jpg';
import html from '../assets/html.png';
import css from '../assets/css.png';
import javascript from '../assets/javascript.png';
import JS from '../assets/js.svg';
import WP from '../assets/wp.svg';
import Shopify from '../assets/shopify.svg';
import Nextjs from '../assets/nextjs.png';
import Astro from '../assets/astro.png';
import sass from '../assets/sass.png';
import react from '../assets/react.png';
import UIUX from '../assets/ui-ux.svg';
import next from '../assets/next-js.svg';
import WebAnimation from '../assets/WebAnimation.svg';
import webDesign from '../assets/webDesign.svg';
import WebDevelopment from '../assets/WebDevelopment.svg';
import mail from '../assets/mail.svg';
import phone from '../assets/phone.svg';
import wp from '../assets/Wordpress-Logo.svg.png';

const exportedObject = {
	logo,
	footerLogo,
	menuBg,
	main,
	html,
	css,
	javascript,
	react,
	next,
	sass,
	UIUX,
	WebAnimation,
	webDesign, 
	wp,
	WebDevelopment,
	phone,
	mail,
	WP,
	JS,
	Shopify,
	Nextjs,
	Astro,
	
};
export default exportedObject;
